export const FacebookIcon = () => (
  <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M40.1885 20.6982C40.1885 9.65137 31.2354 0.698242 20.1885 0.698242C9.1416 0.698242 0.188477 9.65137 0.188477 20.6982C0.188477 30.6826 7.50098 38.9561 17.0635 40.4561V26.4795H11.9854V20.6982H17.0635V16.292C17.0635 11.2803 20.0479 8.51074 24.6182 8.51074C26.8057 8.51074 29.0947 8.90137 29.0947 8.90137V13.8232H26.5713C24.0869 13.8232 23.3135 15.3662 23.3135 16.9482V20.6982H28.8604L27.9736 26.4795H23.3135V40.4561C32.876 38.9561 40.1885 30.6826 40.1885 20.6982Z"
      fill="white"
    />
  </svg>
);
